import { AppModule } from '../../lib/app-module';
import { validateEmail } from '../../lib/validation';

interface StripeExport {
    submitPay: (event: SubmitEvent, idSuffix: string) => boolean
}

export class Stripe extends AppModule<undefined, StripeExport> {
    protected init(): void {
        this._export = {
            submitPay: (event: SubmitEvent, idSuffix: string): boolean => this.submitPay(event, idSuffix)
        };
    }

    private submitPay(event: SubmitEvent, idSuffix: string): boolean {
        const isEmailValid = Stripe.performEmailValidation(idSuffix);
        const agreesWithTerns = Stripe.performTermsAgreementValidation(idSuffix);
        const shippingRegion = Stripe.performShippingRegionValidation(event.target as HTMLFormElement, idSuffix);
        if (isEmailValid && agreesWithTerns && shippingRegion) {
            return true;
        }
        event.preventDefault();
        return false;
    }

    private static performShippingRegionValidation(target: HTMLFormElement, idSuffix: string): boolean {
        const shippingRegion = document.getElementById(`stripe-shipping_${idSuffix}`) as HTMLSelectElement;
        if (!shippingRegion) {
            return true;
        }
        const fieldDiv = document.getElementById(`field-shipping_${idSuffix}`) as HTMLElement;
        if (!shippingRegion.value) {
            fieldDiv.classList.add('error');
            return false;
        }
        target.action = shippingRegion.value;
        fieldDiv.classList.remove('error');
        return true;
    }

    private static performEmailValidation(idSuffix: string): boolean {
        const inputEmail = document.getElementById(`stripe-email_${idSuffix}`) as HTMLInputElement;
        const fieldDiv = document.getElementById(`field-email_${idSuffix}`) as HTMLElement;
        if (!validateEmail(inputEmail.value)) {
            fieldDiv.classList.add('error');
            return false;
        }
        fieldDiv.classList.remove('error');
        return true;
    }

    private static performTermsAgreementValidation(idSuffix: string): boolean {
        const inputAgreement = document.getElementById(`stripe-agreement_${idSuffix}`) as HTMLInputElement;
        const fieldDiv = document.getElementById(`field-agreement_${idSuffix}`) as HTMLElement;
        if (!inputAgreement.checked) {
            fieldDiv.classList.add('error');
            return false;
        }
        fieldDiv.classList.remove('error');
        return true;
    }
}